import { Button } from '../../components/button';
import { Loader } from '../../components/loader';
import { ErrorBox } from '../../components/error-box';
import { useBackgroundSubmission } from './hooks/use-background-submission';
import * as S from './styles';

export const TusenTakkRoute = () => {
    const { submissionState } = useBackgroundSubmission();

    const handleAvslutt = () => {
        window.location.href = 'https://eiendomsfinans.no/';
    };

    // Show error state
    if (submissionState === 'error') {
        return (
            <ErrorBox>
                <a href="https://www.eiendomsfinans.no/">
                    <Button variant="primary">Avslutt</Button>
                </a>
            </ErrorBox>
        );
    }

    // Show loader while submitting
    if (submissionState === 'loading') {
        return (
            <S.PageContainer>
                <S.ContentContainer>
                    <S.Text>
                        Vi jobber nå med å ferdigstille din lånesøknad.
                        Dette tar vanligvis 5-10 sekunder. Vennligst vent.
                    </S.Text>
                    <Loader />
                </S.ContentContainer>
            </S.PageContainer>
        );
    }

    // Show success message
    return (
        <S.PageContainer>
            <S.ContentContainer>
                <S.Title>Tusen takk!</S.Title>
                <S.TextContainer>
                    <S.Text>
                        Vi jobber nå med å ferdigstille din lånesøknad ovenfor bankene.
                    </S.Text>
                    <S.Text>
                        Din personlige rådgiver vil ta kontakt for videre oppfølging.
                    </S.Text>
                </S.TextContainer>
                <S.ButtonContainer>
                    <S.StyledButton 
                        variant="secondary" 
                        onClick={handleAvslutt}
                        tabIndex={0}
                        aria-label="Avslutt og gå til hjemmeside"
                    >
                        Avslutt
                    </S.StyledButton>
                </S.ButtonContainer>
            </S.ContentContainer>
        </S.PageContainer>
    );
};
